import { constants } from "../../../constants";

export default class GamePaused {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        this.gb.emitters.emit.web.gamePaused(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.EYE:
                event["uiBlocked"] = this._default;
                break;

            default:
                event["gamePaused"] = this._default;
        }

        return event;
    }
}
